import styled, { css } from 'styled-components';
import { always, cond, T, propEq } from 'ramda';

import { media } from '@theme/media';
import { CUSTOM_FIELDS, LAYOUT_M_OPTIONS } from '@modules/plp/plp.constants';
import { OFFSET } from '@theme/helpers';

export const GridList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;
  padding: 0 ${OFFSET.S};

  ${media.tablet} {
    grid-template-columns: 1fr 1fr 1fr;
    padding: 0 ${OFFSET.M};
  }
`;

const getGridStyles: (...rest: any) => any = cond([
  [propEq(CUSTOM_FIELDS.LAYOUT_M, LAYOUT_M_OPTIONS.COLUMN_1_LEFT_MARGIN), always('padding-right: calc(50% - 13px);')],
  [propEq(CUSTOM_FIELDS.LAYOUT_M, LAYOUT_M_OPTIONS.COLUMN_1_RIGHT_MARGIN), always('padding-left: calc(50% - 13px);')],
  [propEq(CUSTOM_FIELDS.LAYOUT_M, LAYOUT_M_OPTIONS.COLUMN_2), always('grid-column: span 2;')],
  [T, always('')],
]);

export const GridItem = styled.div`
  position: relative;
  margin: 0;
  width: 100%;
  text-align: center;
`;

export const GridItemContainer = styled.div<{
  [CUSTOM_FIELDS.LAYOUT_M]: LAYOUT_M_OPTIONS | false;
  isDefaultGrouping: boolean;
}>`
  padding: 0 10px 10px;
  position: relative;
  margin: 0;
  width: 100%;
  text-align: center;

  ${media.tablet} {
    padding: 0 30px 80px;
    ${getGridStyles};

    ${(props) =>
      props.isDefaultGrouping &&
      !props[CUSTOM_FIELDS.LAYOUT_M] &&
      css`
        &:nth-child(even) {
          grid-column: span 2;
        }
      `}
  }
`;
